import axios from 'axios'
import { NOTIFICAR_ENTREGA_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function notificarEntregaEncomenda (idEncomenda, idEmpresa) {

  const url = `${URL}/encomendas/${idEncomenda}/empresa/${idEmpresa}/notificar-entrega`;
  return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: NOTIFICAR_ENTREGA_ENCOMENDA,
        payload: response

      })
  );
}
